import React, { FC, useState } from 'react';
import { Button, Multiselect, ToastMessage } from '@cokitchen/cokitchen-components';
import LocalModal from 'components/base/local-modal';
import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';
import { handleApiError } from 'utils/functions';
import useDashboardContext from 'contexts/dashboard.context';
import { DealType } from 'models/deals.model';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  deal: DealType;
};

interface DuplicateDealModalFooterProps {
  onConfirm: () => void;
  loading: boolean;
  disabled: boolean;
}

const DuplicateDealModalFooter: FC<DuplicateDealModalFooterProps> = ({
  onConfirm,
  loading,
  disabled
}) => (
  <div className='flex justify-end'>
    <Button
      small
      color='primary'
      variant='block'
      className='max-w-fit'
      onClick={onConfirm}
      loading={loading}
      disabled={disabled}>
      Confirm
    </Button>
  </div>
);
const DuplicateDealModal = ({ isOpen, onClose, deal }: Props) => {
  const [loading, setLoading] = useState(false);
  const [cokitchenIds, setCokitchenIds] = useState<string[]>([]);

  const { cokitchens, activeCokitchen } = useDashboardContext();

  const duplicateDeal = async () => {
    setLoading(true);
    try {
      const payload: Partial<DealType> = { ...deal };
      delete payload.cokitchen_id;
      delete payload.id;
      await apiService.post('marketing/deal', {
        data: { ...payload, cokitchen_ids: cokitchenIds },
        isInternal: true
      });
      toast(<ToastMessage type='success' message='Deal duplicated successfully' />);
      onClose();
    } catch (err) {
      handleApiError(err);
    } finally {
      setLoading(false);
    }
  };

  const cokitchenOptions = cokitchens
    .filter((c) => c.id !== activeCokitchen.id)
    .map((c) => ({
      text: c.name,
      value: c.id
    }));
  return (
    <LocalModal
      isOpen={isOpen}
      onRequestClose={onClose}
      title={'Duplicate Deal'}
      contentClassName='!max-w-[450px] !min-h-[400px]'
      footer={
        <DuplicateDealModalFooter
          onConfirm={duplicateDeal}
          loading={loading}
          disabled={cokitchenIds.length < 1}
        />
      }>
      <div className=''>
        <label className='font-medium'>Select Cokitchen(s)</label>
        <Multiselect
          placeholder='Select Cokitchen(s)'
          values={cokitchenIds}
          options={cokitchenOptions}
          onChange={(cokitchenIds) => setCokitchenIds(cokitchenIds)}
          hasSearch
          filterResults
        />
      </div>
    </LocalModal>
  );
};

export default DuplicateDealModal;
